<section>
<div class="col ">
  <div class="inner-box">
    <div class="row mt-3">


      <div class="col-md-3 mb-3 ms-3">
        <label>&nbsp;Banner Image</label>
        <div *ngIf="!imageUrl" class="upload-box" id="uploadLogo">
          <input (change)="loadImage($event)" type="file">
          <svg class="bi bi-plus" fill="currentColor" height="2em" viewBox="0 0 16 16" width="2em"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                  fill-rule="evenodd"/>
          </svg>
          <div>Upload Logo</div>
        </div>
        <div *ngIf="imageUrl" class="upload-box mt-2">
          <img class="shift-uploaded-img shift-image"
               height="250"
               src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}" width="250"/>
          <div [hidden]="!errorMessage" class="invalid-feedback d-block shift-invalid-text">{{errorMessage}}</div>
          <div class="overly">
            <button class="btn">
              <input (change)="loadImage($event)" class="plus-upload-btn" type="file">
              <svg class="bi bi-plus" fill="currentColor" height="2em" viewBox="0 0 16 16" width="2em"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                      fill-rule="evenodd"/>
              </svg>
              Upload
            </button>
            <button (click)="ignoreImage()" class="btn">
              <svg class="bi bi-plus" fill="currentColor" height="2em" viewBox="0 0 16 16" width="2em"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                      fill-rule="evenodd"/>
              </svg>
              Remove
            </button>
          </div>
        </div>
      </div>
      </div>
      <div class="row">
      <div class="col-md-3 mb-3 ms-3">
        <label>&nbsp;Mobile Banner Image</label>
        <div *ngIf="!imageUrl" class="upload-box" id="uploadLogo">
          <input (change)="loadImage($event)" type="file">
          <svg class="bi bi-plus" fill="currentColor" height="2em" viewBox="0 0 16 16" width="2em"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                  fill-rule="evenodd"/>
          </svg>
          <div>Upload Logo</div>
        </div>
        <div *ngIf="imageUrl" class="upload-box mt-2">
          <img class="shift-uploaded-img shift-image"
               height="250"
               src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}" width="250"/>
          <div [hidden]="!errorMessage" class="invalid-feedback d-block shift-invalid-text">{{errorMessage}}</div>
          <div class="overly">
            <button class="btn">
              <input (change)="loadImage($event)" class="plus-upload-btn" type="file">
              <svg class="bi bi-plus" fill="currentColor" height="2em" viewBox="0 0 16 16" width="2em"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                      fill-rule="evenodd"/>
              </svg>
              Upload
            </button>
            <button (click)="ignoreImage()" class="btn">
              <svg class="bi bi-plus" fill="currentColor" height="2em" viewBox="0 0 16 16" width="2em"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                      fill-rule="evenodd"/>
              </svg>
              Remove
            </button>
          </div>
        </div>
      </div>
      </div>


    <form class="mt-4">
      <div class="form-group m-3">
        <div>
          <label>Alernate Text</label>
          <input type="text" class="form-control" placeholder="Alternate text"/>
        </div>
      </div>

    <div class="form-group m-3">
      <label>BannerUrl</label>
      <input type="text" class="form-control" id="imageUrl" placeholder="BannerUrl">

    </div>



      <div class="col text-right">
        <button  class="btn btn-orange" id="save" type="submit">Save</button>

      </div>


    </form>
</div>

</div>

</section>
